// <s-header-scroll> marks the header as scrolled once the page leaves the top,
// so an overlay header over the homepage hero can switch to its solid treatment.
class SHeaderScroll extends HTMLElement {
  #frame = 0;
  #onScroll = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  connectedCallback() {
    this.#update();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }

  #update() {
    const target = this.closest('header') ?? this;
    target.toggleAttribute('data-scrolled', window.scrollY > 24);
  }
}

if (!customElements.get('s-header-scroll')) customElements.define('s-header-scroll', SHeaderScroll);
